const APIS: any = {
    USERS: {
        LOGIN: '/users/login/',
        LOGOUT: '/users/logout/',
        GET_LOGGED_USER: '/users/mev2/',
        UPDATE_LOGGED_USER: '/users/update/my/details/',
        GET_ALL_USERS: '/users/all/',
        GET_NEW_ACCESS_TOKEN: '/users/token-refresh',
        ADMIN_INVITE: '/users/admininvite/',
        USER_INVITE: '/users/userinvite/',
        EDIT_INVITE: '/users/update/',
        REINVITE: '/users/reinvite/',
        DELETE_INVITE: '/users/',
        SET_NEW_PASSWORD: '/users/set-new-password/',
        CHANGE_PASSWORD: '/users/change-password/',
        FORGOT_PASSWORD: '/users/forgot-password/',
        ACCEPT_AGREEMENT: '/users/accept-agreement/',
        UPDATE_IMAGE: '/users/updateimage/',
        VALIDATE_TOKEN: '/users/validatetoken/',
    },
    SETTINGS: {
        GET_ALL_SETTINGS: '/users/settings/details/',
        GET_USER_GROUP: '/users/getusergroup/',
        USER_SETTINGS: '/users/settings/',
    },
    MAPS: {
        GET_DROPDOWN: '/maps/dropdown',
        GET_GEO_DROPDOWN: '/maps/geodropdown',
        GET_GEO_DROPDOWN_V3: '/maps/geodropdownv3',
        GET_GEO_DROPDOWN_V4: '/maps/geodropdownv5',
        GET_GEO_DROPDOWN_V5: '/maps/geodropdownv5',
        GET_MAPS: '/maps/getMapData',
        GET_CIRCLE: '/maps/getcircle',
        GET_CIF_DATA: '/maps/cif',
        GET_EXPLORE_NOW: '/maps/explorenowv2',
        GLOBAL_SEARCH: '/maps/geosearch',
        GET_CORE_SOLUTIONS: '/maps/coresolutionfilter',
        GET_MY_PRESENCE: '/maps/getmypresence',
        GET_CURRENCIES: '/maps/currencydropdown',
        GET_POI_MAP_COLOR: '/maps/getmapcolor',
        GET_POI_MAP_COLOR_V3: '/maps/getmapcolorv3',
        GET_TOP_DISTRICTS: '/maps/gettopdata',
        GET_BRANDS: '/maps/viewbrands',
        GET_MAP_PROPERTIES: '/maps/mapproperties',
        GET_MAP_PROPERTIES_V5: '/maps/mappropertiesv5',
        GET_MAP_BOUNDARY: '/maps/mapboundary',
        GET_MAP_BOUNDARY_V5: '/maps/mapboundaryv7sse', // Now supports SSE streaming
        GET_TOP_REGIONS_EXTENDED: '/maps/topRegionsExtended',
        GET_TOP_REGIONS_EXTENDED_V2: '/maps/topRegionsExtendedv2',
        GET_TOP_POIS: '/maps/viewbrandstableV3',
        GET_CATCHMENT_TYPES: '/compare/getcatchmentdata',

    },
    STORIES: {
        GET_ALL_STORIES: '/story/viewstory',
        GET_FEATURED_STORIES: '/story/featuredstory',
    },
    CIF: {
        GET_INOUTFLOW_DATA: '/cif/inflowoutflow',
        GET_EH_GROWTH_DATA: '/cif/ehgrowth',
        GET_METRIC_BREAKDOWN: '/cif/metricbreakdown',
        GET_GEO_SPECIFIC_DATA: '/cif/headingtable',
        GET_CORE_SOLUTIONS_DATA: '/cif/bubblegraph',
        SEND_EMAIL: '/cif/request-email',
        GET_POI_CATEGORIES: '/cif/getcategory/',
        GET_BASIC_CIF: '/cif/getbasiccif/',
        GET_CIF_CTV: '/cif/getCifCtvData/',
        GET_CIF_POI: '/cif/getCifPoiDataByCategory/',
        GET_POI_CAT_DETAILS: '/cif/poicategory/',
        GET_POI_BY_YEAR: '/api/getPoiByTimePeriod/',
        GET_MY_PRESENCE_CONFIG: '/cif/presenceconfig',
        GET_MBP_V2: '/cif/getbranchnew',
        GET_OVERLAY_FILTERS: '/cif/filterbyoverlays/',
        GET_SLIDER_DATA: '/cif/slideroverlays/',
        GET_FILTERED_DISTRICTS: '/cif/filterdistrictscount/',
    },
    ANALYTICS: {
        USERMETRICS: "/analytics/usermetrics"
    },
    DASHBOARD: {
        GET_BAR_GRAPH: '/api/getBarGraph/',
        GET_BREAKDOWN_TABLE_DATA: '/cif/gettabledata/',
        GET_TREE_MAP: '/api/getTreeMap/',
        GET_TREE_MAP_FOR_SELECTED_CATEGORY: '/api/getDeepDiveTreeMap/',
        GET_HIGHLIGHTS_FOR_ALL_CATEGORIES: '/api/getInsightsHighlights/',
        GET_KPI_VALUES: '/cif/getkpivalues',
        GET_GROWTHINTIME_POIDATA: "/api/getGrowthInTimePoiData/",
        GET_GROWTHINTIME_POIDATA_BY_CATEGORY: '/api/getGrowthInTimePoiDataByCategory/',
        GET_GROWTHINTIME_POIDATA_BY_SUBCATEGORY: '/api/getGrowthInTimePoiDataBySubCategory/',
        GET_GROWTHRATE_ALL_SUBCATEGORIES: '/api/getGrowthRateAllSubCategories/',
        REQUEST_DOWNLOAD_DATA: '/cif/requestdata',
        GET_DEEP_DIVE_HIGHLIGHTS: '/api/getDeepDiveHighlightsView/',
        GET_FILTERED_HIGHLIGHTS: '/api/getFilteredHighlights/',
        GET_PRESENCE_DETAILS: '/cif/presencedetails/',
        GET_FILTERED_DROPDOWN: '/cif/filterdropdown/',
        GET_MBP_TABLE_DATA:'/cif/mbptable/',
        GET_MBP_GRAPH_DATA:'/cif/mbpgraph/'
    },
    HELP: {
        POST_QUERIES: '/users/anyqueries/',
        GET_FAQS: '/users/faqs/',
        GET_PRODUCT_TOUR: '/cif/getproducttour',
    },
    COMPARE : {
        GET_COMPARE_LIST: '/compare/addtocompare/',
        GET_STACKRANK: '/compare/stackrankdropdown/',
        GET_BAR_GRAPH: '/compare/poiinsightsbygeoid/',
        GET_PoI_GROWTH: '/compare/getpoigrowthgraph/',
        // GET_ALL_LOCATIONS : '/compare/geodropdowncompare/',
        GET_ALL_LOCATIONS : '/compare/geodropdowncomparenew/',
        GET_SCATTER_GRAPH : '/compare/getpoiscatterplotdata/',
        GET_STACK_BAR_LINE_GRAPH: '/compare/getStackLineGraph/',
        GET_COMPARE_TABLE : '/compare/comparetable/',
        GET_STACK_GRAPH_DROPDOWN: '/compare/getStackLineConfig/',
        GET_SUB_CAT_GROWTH:'/compare/getpoisubcatgrowthgraph/',
        GET_BAR_GRAPH_DROPDOWN: '/users/comparison-poi-bar-graph-dropdown/',
        GET_ALL_VILLAGES: '/compare/villagegeodropdowncompare/',
        GET_TOP_DISTRICTS: '/compare/topDistrictForComparison/',
        GET_COMPARISON_TYPES: '/compare/getComparisonType',
        GET_ALL_CATCHMENTS: '/compare/catchmentmodal',
    },
    LAYERS: {
        GET_LAYER_OVERVIEW: '/datapoints/layeroverview/',
        BROWSE_DATA_SOURCES: '/datapoints/browsedatasource/',
        DATA_PREVIEW: '/datapoints/datasetpreview/',
        DELETE_LAYER: '/api/deletelayer/',
    }
}

export { APIS };